/**
 * Generate a random alphanumeric string to avoid ID collisions
 * @param {number} length - Length of the string (default: 8)
 * @returns {string} Random alphanumeric string
 */
function generateRandomString(length = 8) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export default generateRandomString;